enum TaskState {
    // Still being finalized by the creator
    DRAFT = 'draft',

    // Published
    PUBLISHED = 'published',

    // Ready for initial stages of the work
    PICKUP_READY = 'pickup_ready',

    // First revision is in progress
    IN_PROGRESS = 'in_progress',

    // Under internal QA
    INTERNAL_QA = 'internal_qa',

    // Under client review
    CLIENT_REVIEW = 'client_review',

    // Client requested revision
    REVISION_REQUIRED = 'revision_required',

    // In revision
    IN_REVISION = 'in_revision',

    // Client approved, awaiting final files
    PRE_DELIVERED = 'pre_delivered',

    // Delivered and closed
    DELIVERED = 'delivered',
}

export default TaskState;
